import { render, staticRenderFns } from "./jijiu-detail-info.vue?vue&type=template&id=09a8ab5b&scoped=true"
import script from "./jijiu-detail-info.vue?vue&type=script&lang=js"
export * from "./jijiu-detail-info.vue?vue&type=script&lang=js"
import style0 from "./jijiu-detail-info.vue?vue&type=style&index=0&id=09a8ab5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8ab5b",
  null
  
)

export default component.exports